import React from 'react';
import { BaseIcon } from '../../base/BaseIcon';
import { IconProps } from '../../types';

export const AttrMediaIcon = React.memo<IconProps>(({ 
  className = '',
  size = 24,
  color = 'currentColor',
  onClick,
  strokeWidth
}) => (
  <BaseIcon
    className={className}
    size={size}
    color={color}
    onClick={onClick}
    viewBox="0 0 24 24"
    strokeWidth={strokeWidth}
  >
    <path d="M12 0C6.21 0 1.24 4.13 0.200002 9.82C0.100002 10.36 0.460002 10.88 1 10.98C1.55 11.08 2.06 10.72 2.16 10.18C3.04 5.44 7.17 2 12 2C17.51 2 22 6.49 22 12C22 16.83 18.56 20.96 13.82 21.84C13.28 21.94 12.92 22.46 13.02 23C13.12 23.55 13.65 23.9 14.18 23.8C19.87 22.75 24 17.79 24 12C24 5.38 18.62 0 12 0Z" fill={color}/>
    <path d="M18.25 12C18.25 11.64 18.06 11.31 17.75 11.13L9.57999 6.46001C9.26999 6.28001 8.88999 6.28001 8.57999 6.46001C8.26999 6.64001 8.07999 6.97001 8.07999 7.32001V16.65C8.07999 17.01 8.26999 17.34 8.57999 17.52C8.88999 17.7 9.26999 17.7 9.57999 17.52L17.75 12.85C18.06 12.67 18.25 12.34 18.25 11.98V12ZM10.08 14.94V9.05001L15.23 11.99L10.08 14.93V14.94Z" fill={color}/>
    <path d="M2.79 15.7C2.58 15.19 2 14.93 1.49 15.14C0.979998 15.35 0.729998 15.93 0.929998 16.44C1.15 17 1.43 17.54 1.76 18.1C2.05 18.58 2.67 18.73 3.13 18.44C3.6 18.16 3.76 17.54 3.48 17.07C3.2 16.6 2.97 16.15 2.79 15.69V15.7Z" fill={color}/>
    <path d="M8.40999 21.26C7.90999 21.06 7.44999 20.84 7.01999 20.58C6.54999 20.3 5.92999 20.46 5.64999 20.93C5.36999 21.41 5.52999 22.02 5.99999 22.3C6.51999 22.6 7.07999 22.88 7.66999 23.11C8.16999 23.31 8.76999 23.07 8.96999 22.55C9.16999 22.04 8.91999 21.46 8.40999 21.25V21.26Z" fill={color}/>
  </BaseIcon>
));

AttrMediaIcon.displayName = 'AttrMediaIcon';
